import ChartContainer from '../Services/charts/apex-charts/ChartContainer';
import { useSimpleBars } from './hooks/useSimpleBars';

export const SimpleBars = ({
    title,
    values = [],
    subtitles = [],
    horizontal = false,
    className = '',
    height = 450,
    series = null,
    isMoney = false,
    showDataLabels = true,
    stacked = false,
    customColors = null,
    decimals = 2,
    tooltipTotals = null
}) => {
    const { chartConfig } = useSimpleBars({
        values,
        subtitles,
        horizontal,
        series,
        isMoney,
        showDataLabels,
        stacked,
        customColors,
        decimals,
        tooltipTotals
    });

    return (
        <ChartContainer
            title={title}
            options={chartConfig.options}
            series={chartConfig.series}
            type="bar"
            height={height ?? 450}
            className={className}
        />
    );
};